var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.tooltip,
    offset: 16
  }),expression:"{\n    content: tooltip,\n    offset: 16\n  }"}],staticClass:"speed-stats-item"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.stats.title))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("round")(_vm.stats.totalDownloadTime,100))+"s")])])])}
var staticRenderFns = []

export { render, staticRenderFns }